import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ReasonButtonContainer, ReasonListContainer } from './styles';
import { parseReasonLabel } from 'pages/RemoteControl/MachineProfile/helpers';
import { ChevronRight } from 'icons';
import { colors } from 'styles/remoteControlColors';
import { RemoteControlReason } from 'providers/types/remoteControl';

interface ReasonListProps {
  reasons: RemoteControlReason[];
  onSelectReason: (reason: RemoteControlReason) => void;
}

const ReasonButton: React.FC<{ reason: RemoteControlReason, onClick: () => void}> = ({
  onClick,
  reason,
}) => {
  const { t } = useTranslation();

  return (
    <ReasonButtonContainer onClick={onClick}>
      <p>{t(parseReasonLabel(reason))}</p>
      <ChevronRight color={colors.Black} />
    </ReasonButtonContainer>
  );
};

export function ReasonList({
  reasons,
  onSelectReason,
}: Readonly<ReasonListProps>): ReactElement {
  const { t } = useTranslation();
  return (
    <ReasonListContainer>
      <p>{t('selecioneMotivoParaEstaAcao')}</p>
      {reasons.map((reason) => (
        <ReasonButton
          reason={reason}
          onClick={() => onSelectReason(reason)}
          key={`button-${reason.toLowerCase()}`}
        />
      ))}
    </ReasonListContainer>
  );
}
